import { render } from "./ConsentDoubleOptinErrorPage.vue?vue&type=template&id=a4ed6362&scoped=true"
import script from "./ConsentDoubleOptinErrorPage.vue?vue&type=script&lang=js"
export * from "./ConsentDoubleOptinErrorPage.vue?vue&type=script&lang=js"

import "./ConsentDoubleOptinErrorPage.vue?vue&type=style&index=0&id=a4ed6362&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ed6362"]])

export default __exports__